import { useSearchParams } from '@remix-run/react';
import { QUERY_KEY } from '../constants';
import { cleanRawQuery } from '../utils';

export const useReportQueryBySearchParam = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get(QUERY_KEY);

  const cleanQuery = cleanRawQuery(query);

  return { query: cleanQuery };
};
